import { ShieldCheck } from "lucide-react";
import vrmLogo from "../assets/VRM_New.jpeg";
import StepRail from "./StepRail";
import "../styles/onboarding.css";

const STEPS = [
  { n: 1, label: "Company", sub: "Tell us about your company" },
  { n: 2, label: "Agreement", sub: "Review and agree" },
  { n: 3, label: "Payment", sub: "Payment details" },
  { n: 4, label: "Proof", sub: "Business proof" },
  { n: 5, label: "Active", sub: "Your account is ready" },
];

function OnboardingShell({ step, children }) {
  return (
    <div className="shell">
      
      {/* Left Sidebar */}
      <aside className="shell-rail">
        <div className="shell-brand">
          <img src={vrmLogo} alt="VRM AI TECHNOLOGY Logo" style={{ height: '70px', width: 'auto', mixBlendMode: 'darken', margin: '0 -15px' }} />
          <div className="shell-brand-text">
            <div className="shell-brand-name">VRM AI TECHNOLOGY</div>
            <div className="shell-brand-sub">Customer Onboarding</div>
          </div>
        </div>

        <StepRail steps={STEPS} current={step} />


      </aside>

      {/* Main Content Wrapper */}
      <div className="shell-content">
        
        {/* Top Navigation Bar */}
        <header className="shell-topbar">
          <div className="topbar-secure">
            <div className="secure-icon"><ShieldCheck size={18} /></div>
            <div className="secure-text">
              <div className="secure-title">Secure onboarding <span className="secure-dot"></span></div>
              <div className="secure-sub">Encrypted & Safe</div>
            </div>
          </div>

          <div className="topbar-progress">
            <div className="progress-label">Step {step} of 5</div>
            <div className="progress-bars">
              {[1, 2, 3, 4, 5].map((i) => (
                <div 
                  key={i} 
                  className={`progress-bar ${i < step ? "progress-bar--done" : i === step ? "progress-bar--active" : ""}`} 
                />
              ))}
            </div>
          </div>

        </header>

        {/* Center Main Form */}
        <main className="shell-main">
          <div className="onboard-card">
            {children}
          </div>
        </main>
      </div>

    </div>
  );
}

export default OnboardingShell;